import { DatasetSubtype, DatasetType } from 'src/app/modules/core/store/models/dataset.model';
import { Folder, LayerTypes, SectionType } from '../../cop/models';

export interface LayerTypesListItem {
  uId: string;
  value: number;
  name: string;
  sections: SectionType[];
  datasetTypes?: DatasetType[];
  datasetSubtypes?: DatasetSubtype[];
}

export const layerTypesList: LayerTypesListItem[] = [
  {
    uId: LayerTypes[LayerTypes.Other],
    value: LayerTypes.Other,
    name: 'Points Of Interest',
    sections: [SectionType.Places],
    datasetTypes: [
      DatasetType.Assets,
      DatasetType.PointOfInterest,
      DatasetType.Camera,
      DatasetType.Alarm,
      DatasetType.Geofence,
      DatasetType.Incident,
      DatasetType.Default
    ],
    datasetSubtypes: []
  },
  {
    uId: LayerTypes[LayerTypes.Asset],
    value: LayerTypes.Asset,
    name: LayerTypes[LayerTypes.Asset],
    sections: [SectionType.Assets],
    datasetTypes: [DatasetType.Assets],
    datasetSubtypes: []
  },
  {
    uId: LayerTypes[LayerTypes.Incident],
    value: LayerTypes.Incident,
    name: LayerTypes[LayerTypes.Incident],
    sections: [SectionType.Incidents],
    datasetTypes: [DatasetType.Incident],
    datasetSubtypes: []
  },
  {
    uId: LayerTypes[LayerTypes.Alert],
    value: LayerTypes.Alert,
    name: LayerTypes[LayerTypes.Alert],
    sections: [SectionType.Alerts],
    datasetTypes: [DatasetType.Alerts, DatasetType.Alarm],
    datasetSubtypes: [DatasetSubtype.TropicalCyclone]
  },
  { uId: LayerTypes[LayerTypes.Tile], value: LayerTypes.Tile, name: LayerTypes[LayerTypes.Tile], sections: [] },
  { uId: LayerTypes[LayerTypes.Image], value: LayerTypes.Image, name: LayerTypes[LayerTypes.Image], sections: [] },
  { uId: LayerTypes[LayerTypes.FloorPlan], value: LayerTypes.FloorPlan, name: LayerTypes[LayerTypes.FloorPlan], sections: [] },
  {
    uId: LayerTypes[LayerTypes.WeatherImagery],
    value: LayerTypes.WeatherImagery,
    name: 'Weather Imagery',
    sections: [SectionType.Weather]
  },
  {
    uId: LayerTypes[LayerTypes.Visualization],
    value: LayerTypes.Visualization,
    name: LayerTypes[LayerTypes.Visualization],
    sections: [SectionType.Visualizations]
  },
  {
    uId: LayerTypes[LayerTypes.HorizonLocationIntelRatings],
    value: LayerTypes.HorizonLocationIntelRatings,
    name: LayerTypes[LayerTypes.HorizonLocationIntelRatings],
    sections: [SectionType.HorizonLocationIntelRatings],
    datasetTypes: [DatasetType.Alerts],
    datasetSubtypes: [DatasetSubtype.HorizonLocationIntelRatings]
  }
];

export function layerTypesFilteredForSection(section: Folder, includeLayerType?: LayerTypes): LayerTypesListItem[] {
  if (!section) {
    return [];
  }
  return layerTypesList.filter(lt => !lt.sections || lt.sections.find(s => s === section.sectionType) || includeLayerType === lt.value);
}

export function layerTypesFilteredForDatasetType(layerTypesList: LayerTypesListItem[], datasetType: DatasetType): LayerTypesListItem[] {
  return layerTypesList.filter(lt => !lt.datasetTypes || lt.datasetTypes.find(t => datasetType === t));
}
